// extracted by mini-css-extract-plugin
export default {"CreateTag":"create-tag_CreateTag__KAzMd"};